module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_9006.6f852f04.png";